<template>
  <div class="document-code-list">
    <div class="query-option">
      <BatchVagueSelect
        v-model="computedValue[changeKey]"
        show-remote
        @selectChange="selectChange"
      />
    </div>
    <AsrAutoComplete
      v-if="computedValue[changeKey] === 2"
      v-model="computedValue[remoteKey]"
      service="web"
      api="getClientNameList"
      param-key="clientName"
      value-key="clientName"
      label-key="clientName"
      placeholder="远程搜索"
      :multiple="true"
      @select="computedValue[remoteKeyValue] = $event?.clientCode ?? ''"
      @change="computedValue[remoteKeyValue] = ''"
    />
    <PasteSelect
      v-else-if="computedValue[changeKey] === 1"
      v-model="computedValue[batchKey]"
      placeholder="精确查询，支持多选"
    />
    <el-input
      v-else
      v-model.trim="computedValue[vagueKey]"
      clearable
      placeholder="模糊查询，请输入客户名称"
    />
  </div>
</template>

<script>
import PasteSelect from '@/components/PasteSelect'
export default {
  name: 'BatchVagueSelectClientName',
  components: {
    PasteSelect
  },
  props: {
    value: {
      type: [Number, String],
      default: 0
    },
    batchKey: {
      type: String,
      default: 'clientNames'
    },
    vagueKey: {
      type: String,
      default: 'clientNames'
    },
    remoteKey: {
      type: String,
      default: 'clientNames'
    },
    remoteKeyValue: {
      type: String,
      default: 'clientCodes'
    },
    changeKey: {
      type: String,
      default: 'isBatchSearchClientName'
    }
  },

  data() {
    return {}
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  methods: {
    selectChange(val) {
      this.computedValue[this.batchKey] = null
      this.computedValue[this.vagueKey] = null
      this.computedValue[this.remoteKey] = null
      this.computedValue[this.remoteKeyValue] = null
    }
  }
}
</script>

<style lang="scss" scoped>
.document-code-list {
  display: flex;
  .el-select,
  .el-input {
    width: auto;
  }
  .query-option {
    display: flex;
    margin-right: 5px;
    .el-form-item__label {
      font-weight: 600;
      flex-shrink: 0;
    }
    .el-select {
      width: 100px;
    }
  }
}
</style>
